const userTypeString = () => {
  let data = {};
  data[userType.REAL] = "حقیقی";
  data[userType.LEGAL] = "حقوقی";

  return data;
};

const userType = {
  REAL: "real",
  LEGAL: "legal",
};

module.exports = {
  userTypeString,
  userType,
};
